import { CSS_VARS } from './constants';

export function addHtmlClass(className) {
  document.documentElement.classList.add(className);
}

export function removeHtmlClass(className) {
  document.documentElement.classList.remove(className);
}

export function toggleHtmlClass(className, force) {
  document.documentElement.classList.toggle(className, force);
}

export function setCssVar(name, value) {
  document.documentElement.style.setProperty(name, value);
}

export function removeCssVar(name) {
  document.documentElement.style.removeProperty(name);
}

export function setFontSizeVar(value) {
  if (value) {
    setCssVar(CSS_VARS.fontSize, value + 'px');
  } else {
    removeCssVar(CSS_VARS.fontSize);
  }
}

export function setLineHeightVar(value) {
  if (value) {
    setCssVar(CSS_VARS.lineHeight, value);
  } else {
    removeCssVar(CSS_VARS.lineHeight);
  }
}

export function setLetterSpacingVar(value) {
  if (value) {
    setCssVar(CSS_VARS.letterSpacing, value);
  } else {
    removeCssVar(CSS_VARS.letterSpacing);
  }
}

let injectedStyleId = null;

export function injectGlobalStyle(cssText) {
  removeInjectedStyle();
  const style = document.createElement('style');
  style.id = 'pb-a11y-injected';
  style.textContent = cssText;
  document.head.appendChild(style);
  injectedStyleId = style.id;
  return style;
}

export function removeInjectedStyle() {
  if (injectedStyleId) {
    const el = document.getElementById(injectedStyleId);
    if (el) el.remove();
    injectedStyleId = null;
  }
}

export function debounce(fn, ms) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), ms);
  };
}

export function throttle(fn, ms) {
  let last = 0;
  return function (...args) {
    const now = Date.now();
    if (now - last >= ms) {
      last = now;
      fn.apply(this, args);
    }
  };
}
